import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Input } from './Input';
export class PopupInput extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "ref", null);
    _defineProperty(this, "handleInnerRef", ref => {
      this.ref = ref;
      if (this.props.innerRef) {
        this.props.innerRef(ref);
      }
    });
  }
  componentDidMount() {
    if (this.ref) {
      // @ts-ignore
      this.ref.select();
    }
  }
  render() {
    return /*#__PURE__*/React.createElement(Input, _extends({}, this.props, {
      innerRef: this.handleInnerRef
    }));
  }
}